export const getErrorMessage = (code) => {
    const map = {
        400: 'Something went wrong.',
        403: 'You don\'t have permission to view this',
        404: 'The thing you\'re requesting doesn\'t exist',
        410: 'The thing you\'re requesting is no longer available.',
        500: 'Oops! Something went wrong.',
        410001: 'This feedback survey is no longer available',
        410002: 'This feedback survey has expired',
    };
    return map?.[code] ?? '';
}
